
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import { useRouter } from 'next/router';
import { GetStaticProps, NextPage } from 'next';
import { NextSeo, BreadcrumbJsonLd } from 'next-seo';
import Stack from '@mui/material/Stack';
import HeaderBar from 'components/atomic/organisms/header';
import FiltersPanel, { FilterGroup, Filter, FilterItem } from 'pages/wiki/filters';
import ResponsiveContainer from 'components/atomic/organisms/responsive-container';
import LanguageCard from 'pages/wiki/item-card/language';
import Footer from 'components/atomic/organisms/footer';
import RightPanel from 'pages/wiki/right-panel';
import useFilters from 'pages/wiki/use-filters';
import ItemList from 'pages/wiki/item-list';
import Hero from 'pages/wiki/hero';
import Routes, { toAbsoluteUrl } from 'utils/routes';
import { LanguageOverview } from 'types/wiki';
import devvSdk from 'utils/devv-sdk';
const SEO = () => {
    const router = useRouter();
    const keywords = [
        'linguaggi di programmazione',
        'linguaggi di markup',
        'linguaggi di scripting',
        'linguaggi di programmazione più utilizzati',
        'linguaggi di programmazione più utili',
    ];
    return (<>
            <NextSeo title="Linguaggi di programmazione" titleTemplate={'%s | Devv'} description="Esplora i linguaggi di programmazione e markup più utili e utilizzati nel mondo. Scopri le loro caratteristiche, i loro ambiti di utilizzo e le loro differenze." canonical={`${toAbsoluteUrl(router.asPath)}`} additionalMetaTags={[
            {
                property: 'keywords',
                content: keywords.join(', '),
            },
        ]} openGraph={{
            url: `${toAbsoluteUrl(router.asPath)}`,
            images: [
                {
                    url: `${toAbsoluteUrl(`/assets/og/wiki-languages.png`)}`,
                    secureUrl: `${toAbsoluteUrl(`/assets/og/wiki-languages.png`)}`,
                    type: 'image/png',
                    width: 1200,
                    height: 630,
                },
            ],
        }}/>
            <BreadcrumbJsonLd itemListElements={[
            {
                position: 1,
                name: 'Wiki',
                item: `${toAbsoluteUrl(Routes.Wiki)}`,
            },
            {
                position: 2,
                name: 'Linguaggi di programmazione',
                item: `${toAbsoluteUrl(Routes.WikiLanguages)}`,
            },
        ]}/>
        </>);
};
interface LanguagesPageProps {
    languages: LanguageOverview[];
    filters: Filter[];
    defaultActiveFilters?: FilterItem[];
}
const LanguagesPage: NextPage<LanguagesPageProps> = (props) => {
    const { addFilter, removeFilter, clearFilters, activeFilters, setSearch, filteredItems } = useFilters(props.languages, props.defaultActiveFilters);
    return (<>
            <SEO />

            <HeaderBar />

            <Hero title="Linguaggi di programmazione" description="Esplora i linguaggi di programmazione e markup più utili e utilizzati nel mondo. Scopri le loro caratteristiche, i loro ambiti di utilizzo e le loro differenze." searchPlaceholder="Cerca un Linguaggio..." onSearch={(s) => setSearch(s)} color="#990038"/>

            <ResponsiveContainer maxWidth={'xl'}>
                <Stack direction={'row'}>
                    <FiltersPanel>
                        {props.filters.map((filter, index) => (<FilterGroup key={index} title={filter.title} items={filter.items} activeFilters={activeFilters} onClear={clearFilters} onAdd={addFilter} onRemove={removeFilter}/>))}
                    </FiltersPanel>

                    <ItemList items={filteredItems} count={filteredItems.length} activeFilters={activeFilters} onRemoveFilter={removeFilter} itemColumns={{ xs: 12, sm: 4, md: 3 }} renderItem={(item) => <LanguageCard item={item}/>}/>

                    <RightPanel />
                </Stack>
            </ResponsiveContainer>

            <Footer />
        </>);
};
const getStaticProps: GetStaticProps<LanguagesPageProps> = async () => {
    const { data: languagesOverview } = await devvSdk.getLanguagesOverview();
    const { data: rolesOverview } = await devvSdk.getRolesOverview();
    const filters = [
        {
            title: 'Filtra per popolarità',
            items: [
                {
                    slug: 'popular',
                    title: 'I più popolari',
                    count: languagesOverview.filter((e) => !!e.logo).length,
                    tags: languagesOverview.filter((e) => !!e.logo).map((e) => e.slug),
                },
            ],
        },
        {
            title: 'Filtra per ruolo',
            items: rolesOverview
                .map((el) => ({
                slug: el.slug,
                title: el.title,
                count: el.categories.filter((el1) => languagesOverview.find((t) => t.slug === el1)).length,
                tags: el.categories.filter((el1) => languagesOverview.find((t) => t.slug === el1)),
            }))
                .filter((el) => el.count > 0)
                .sort((a, b) => b.count - a.count),
        },
    ];
    return {
        props: {
            languages: languagesOverview,
            filters,
            defaultActiveFilters: filters[0].items,
        },
    };
};
export default LanguagesPage;

    async function __Next_Translate__getStaticProps__18916ceb2cd__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/wiki/languages/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18916ceb2cd__ as getStaticProps }
  